import { render, staticRenderFns } from "./bf.vue?vue&type=template&id=231346ad"
import script from "./bf.vue?vue&type=script&lang=js"
export * from "./bf.vue?vue&type=script&lang=js"
import style0 from "./bf.vue?vue&type=style&index=0&id=231346ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports